import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import Modal from 'react-bootstrap/Modal'
import { Offcanvas, Card } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import RichTextPreview from 'components/RichText/RichTextPreview'

import './publicaciones.css'

const TIPO_VIDEO = 'video'
const TIPO_GALERIA = 'galeria'

function VerPublicacion(props) {
    const { publicacion, setQueMostrar } = props

    const [lightboxOpen, setLightboxOpen] = useState(false)
    const [imagenActiva, setImagenActiva] = useState(0)

    const esBorrador = publicacion.borrador === '1' ||
        publicacion.borrador === 1 ||
        publicacion.borrador === true

    // Formatear fecha
    const formatearFecha = (fechaString) => {
        if (!fechaString) return 'No disponible'
        const fecha = new Date(fechaString)
        return fecha.toLocaleDateString('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    // Renderizar contenido
    const renderContenido = () => {
        if (!publicacion.contenido) return <p className="text-muted">No hay contenido disponible</p>

        try {
            const contenidoJSON = JSON.parse(publicacion.contenido)
            return <RichTextPreview rawContent={contenidoJSON} />
        } catch (e) {
            return <div className="contenido-text">{publicacion.contenido}</div>
        }
    }

    // Obtener ID de YouTube
    const getYouTubeId = () => {
        if (publicacion.youtubeId) return publicacion.youtubeId

        if (!publicacion.videoUrl) return null

        const patterns = [
            /youtube\.com\/watch\?v=([^&]+)/,
            /youtube\.com\/embed\/([^?]+)/,
            /youtu\.be\/([^?]+)/
        ]

        for (const pattern of patterns) {
            const match = publicacion.videoUrl.match(pattern)
            if (match) return match[1]
        }

        if (publicacion.videoUrl.length === 11) return publicacion.videoUrl
        return null
    }

    // Abrir lightbox
    const abrirLightbox = (index) => {
        setImagenActiva(index)
        setLightboxOpen(true)
    }

    // Navegar en lightbox
    const navegarLightbox = (direccion) => {
        const total = publicacion.imagenes?.length || 0
        let nuevaImagen = imagenActiva + direccion

        if (nuevaImagen < 0) nuevaImagen = total - 1
        if (nuevaImagen >= total) nuevaImagen = 0

        setImagenActiva(nuevaImagen)
    }

    const handleClose = () => {
        setQueMostrar('')
    }

    const youtubeId = getYouTubeId()

    return (
        <>
            <Offcanvas show={true} onHide={handleClose} placement="end" className="publicacion-panel publicacion-detalle-panel">
                <PanelHeader
                    onClick={handleClose}
                    iconClass="fa-arrow-left"
                    btnText="Atras"
                    text={esBorrador ? "Publicacion (Borrador)" : "Publicacion"}
                />
                <Offcanvas.Body id="ver-publicacion" className="pb-0">
                    <Card className="publicacion-card mb-4 border-0 shadow-sm">
                        {/* Header */}
                        <Card.Header className={`publicacion-header-card ${publicacion.tipo}`}>
                            <div className="d-flex justify-content-between align-items-start">
                                <Badge bg="light" text="dark" className="tipo-badge-grande">
                                    <i className={`fa fa-${publicacion.tipo === TIPO_VIDEO ? 'play-circle' : 'images'} me-2`}></i>
                                    {publicacion.tipo === TIPO_VIDEO ? 'Video' : 'Galeria'}
                                </Badge>

                                {esBorrador && (
                                    <Badge bg="warning" className="estado-badge">
                                        <i className="fa fa-pencil-alt me-1"></i> Borrador
                                    </Badge>
                                )}
                            </div>

                            <div className="fecha-publicacion mt-3">
                                <i className="fa fa-calendar-alt me-2"></i>
                                {formatearFecha(publicacion.fecha)}
                            </div>
                        </Card.Header>

                        <Card.Body>
                            {/* Etiquetas */}
                            <div className="mb-3">
                                {publicacion.etiquetas && publicacion.etiquetas.length > 0 ? (
                                    publicacion.etiquetas.map((etiqueta, index) => (
                                        <Badge
                                            key={index}
                                            bg="primary"
                                            className="me-2 mb-2 px-3 py-2"
                                        >
                                            {etiqueta.nombre}
                                        </Badge>
                                    ))
                                ) : (
                                    <Badge bg="secondary" className="px-3 py-2">
                                        Sin etiquetas
                                    </Badge>
                                )}
                            </div>

                            {/* Titulo */}
                            <h1 className="titulo-publicacion">{publicacion.titulo}</h1>

                            {/* Autor */}
                            {publicacion.autor && (
                                <div className="autor-publicacion mb-4">
                                    <i className="fa fa-user me-2"></i>
                                    Por <strong>{publicacion.autor}</strong>
                                </div>
                            )}

                            {/* Copete */}
                            {publicacion.copete && (
                                <div className="copete-container mb-4">
                                    <div className="copete-publicacion">
                                        {publicacion.copete}
                                    </div>
                                </div>
                            )}

                            {/* VIDEO */}
                            {publicacion.tipo === TIPO_VIDEO && youtubeId && (
                                <div className="video-container mb-4">
                                    <div className="ratio ratio-16x9">
                                        <iframe
                                            src={`https://www.youtube.com/embed/${youtubeId}`}
                                            title={publicacion.titulo}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            )}

                            {/* GALERIA */}
                            {publicacion.tipo === TIPO_GALERIA && publicacion.imagenes && publicacion.imagenes.length > 0 && (
                                <div className="galeria-container mb-4">
                                    <div className="galeria-preview-grid">
                                        {publicacion.imagenes.map((img, index) => (
                                            <div
                                                key={img.id}
                                                className="galeria-preview-item"
                                                onClick={() => abrirLightbox(index)}
                                            >
                                                <img
                                                    src={process.env.REACT_APP_API_URL + img.url}
                                                    alt={`Imagen ${index + 1}`}
                                                />
                                                <div className="galeria-overlay">
                                                    <i className="fa fa-search-plus"></i>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <small className="text-muted">
                                        <i className="fa fa-images me-1"></i>
                                        {publicacion.imagenes.length} imagenes - Clic para ampliar
                                    </small>
                                </div>
                            )}

                            {/* Contenido */}
                            <div className="contenido-container">
                                {renderContenido()}
                            </div>
                        </Card.Body>
                    </Card>
                </Offcanvas.Body>
                <PanelFooter>
                    <Button variant="primary" onClick={handleClose} className="w-100">
                        Cerrar
                    </Button>
                </PanelFooter>
            </Offcanvas>

            {/* Lightbox para galeria */}
            <Modal
                show={lightboxOpen}
                onHide={() => setLightboxOpen(false)}
                size="xl"
                centered
                className="lightbox-modal"
            >
                <Modal.Header closeButton closeVariant="white">
                    <Modal.Title>
                        Imagen {imagenActiva + 1} de {publicacion.imagenes?.length || 0}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-0">
                    {publicacion.imagenes && publicacion.imagenes[imagenActiva] && (
                        <img
                            src={process.env.REACT_APP_API_URL + publicacion.imagenes[imagenActiva].url}
                            alt={`Imagen ${imagenActiva + 1}`}
                            className="lightbox-image"
                        />
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button
                        variant="outline-light"
                        onClick={() => navegarLightbox(-1)}
                        disabled={!publicacion.imagenes || publicacion.imagenes.length <= 1}
                    >
                        <i className="fa fa-chevron-left me-2"></i>
                        Anterior
                    </Button>
                    <Button
                        variant="outline-light"
                        onClick={() => navegarLightbox(1)}
                        disabled={!publicacion.imagenes || publicacion.imagenes.length <= 1}
                    >
                        Siguiente
                        <i className="fa fa-chevron-right ms-2"></i>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default VerPublicacion
